define('datasource-manager/lib/resolveParams',['require','exports','module'],function(require,exports,module){
    var UNDEF,          
        AMP         = "&",
        EMPTY       = "",
        regexcomma  = /\,/g,
        regexpars   = /(&?\w+\=['"]?)?\{(\w+)(?:\:([^}]+))?\}(['"])?/g,
        _params     = {};


    function replace(match,$0,$1,$2,$3){
        var val=(_params[$1] || $2);
        val = val===UNDEF ? EMPTY : val+($3||EMPTY);
        return ($0 ? $0 + (val+EMPTY).replace(regexcomma,($3||EMPTY)+AMP+$0) : val);
    }

    return function(str,params){
        _params=params||{};
        return str && str.replace(regexpars,replace)||EMPTY;
    };
});
